import React from 'react';

import { Box, Typography, Grid, IconButton } from '@mui/material';
import Tooltip from 'components/Tooltip';

import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';

type Props = {
  contentType: string;
  articleId: string;
  lastReviewed: string;
};

const ContactInfo = ({ contentType, articleId, lastReviewed }: Props) => {
  return (
    <Box
      sx={{
        py: 3,
        px: 2,
      }}
    >
      <Box display="flex" columnGap={1}>
        <Tooltip title="Email" placement="top" arrow>
          <IconButton>
            <MailOutlineRoundedIcon color="primary" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Print" placement="top" arrow>
          <IconButton>
            <PrintRoundedIcon color="primary" />
          </IconButton>
        </Tooltip>
      </Box>

      <Box py={2}>
        <Typography variant="body1">Documentation</Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: 1,
          '.MuiTypography-subtitle1': {
            color: 'text.disabled',
            fontWeight: 700,
          },
        }}
      >
        <Grid container>
          <Grid item xs={6} md={12}>
            <Typography variant="subtitle1">Content Type</Typography>
          </Grid>

          <Grid item xs={6} md={12}>
            <Typography variant="body1">{contentType}</Typography>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={6} md={12}>
            <Typography variant="subtitle1">Article ID</Typography>
          </Grid>

          <Grid item xs={6} md={12}>
            <Typography variant="body1">{articleId}</Typography>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={6} md={12}>
            <Typography variant="subtitle1">Last Reviewed</Typography>
          </Grid>

          <Grid item xs={6} md={12}>
            <Typography variant="body1">{lastReviewed}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ContactInfo;
